import React__default from 'react';
import { MainContent as MainContent$2 } from './MainContent.styles.js';

var MainContent = function MainContent(_ref) {
  var content = _ref.content;
  // If it is coming from the CSM, filter out empty paragraphs. Otherwise, render the content as is.
  if (!content || !Array.isArray(content)) {
    return /*#__PURE__*/React__default.createElement(MainContent$2, {
      className: "main-content"
    }, content);
  }

  // remove empty paragraphs from content
  var filteredContent = content === null || content === void 0 ? void 0 : content.filter(function (item) {
    var _item$props;
    return (item === null || item === void 0 || (_item$props = item.props) === null || _item$props === void 0 || (_item$props = _item$props.children) === null || _item$props === void 0 || (_item$props = _item$props[0]) === null || _item$props === void 0 ? void 0 : _item$props[1]) !== '';
  });
  return /*#__PURE__*/React__default.createElement(MainContent$2, {
    className: "main-content"
  }, filteredContent);
};

/* eslint-enable react/no-danger */
var MainContent$1 = MainContent;

export { MainContent$1 as default };
//# sourceMappingURL=MainContent.js.map
